import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { DistriMarketPage } from '@/features/distrimarket/pages/DistriMarketPage'

const searchSchema = z.object({
  tab: z
    .enum(['listings', 'orders', 'flash-sales', 'group-buys', 'live', 'chat', 'payments', 'posts', 'analytics', 'promos', 'reviews', 'settings'])
    .catch('listings'),
})

export const Route = createFileRoute('/_dm/distrimarket/')({
  validateSearch: searchSchema,
  component: DistriMarketPage,
})
